/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { Text } from "@fluentui/react/lib/Text";
import ListaVerificacionService from "../../services/listaVerificacionService";
import {
  ICommandBarItemProps,
  Modal,
  TooltipHost,
  Stack,
  Label,
} from "@fluentui/react";
import { Panel, PanelType } from "@fluentui/react/lib/Panel";
import { DefaultButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { useBoolean } from "@fluentui/react-hooks";
import { Image, ImageFit } from "@fluentui/react/lib/Image";
import { Separator } from "@fluentui/react/lib/Separator";
import { TextField } from "@fluentui/react/lib/TextField";
import {
  ChoiceGroup,
  IChoiceGroupOption,
} from "@fluentui/react/lib/ChoiceGroup";

import { getTheme } from "@fluentui/react/lib/Styling";
import {
  DetailsListLayoutMode,
  IColumn,
} from "@fluentui/react/lib/DetailsList";
import { useState, useEffect } from "react";
import { Icon } from "@fluentui/react/lib/Icon";
import {
  IItemListaVerificacion,
  IDetalleListaVerificacion,
  IAuditoria,
} from "../../Interfaces/IListaVerificacion";
import { HeadingBar } from "../../components/generic/HeadingBar";
import {
  baseSearch,
  _initialFilter,
  _initialPagination,
} from "../../utils/helpers/helpers";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PanelGenerico } from "../../components/generic/PanelGenerico";
import themeBase from "../../utils/theme/themeBase";
import { formatDate_DDMMYY } from "../../utils/helpers/dateHelpers";
import BaseTelelirk, {
  ETelerikViewmode,
} from "../../components/generic/baseTelerik";
import { IPagination } from "../../Interfaces/base/ITable";
import Estado from "../../components/elements/Estado";
import { TableBase } from "../../components/Table/TableBase";
import IconHelper from "../../utils/helpers/iconHelper";
import PersonaTag from "../../components/elements/Persona";
import COLORES from "../../utils/theme/colores";
import ReporteHistoricoChecklist from "./ReporteHistoricoChecklist";
import { PanelFIltroHistorialAdmin } from "./historial/AdminHistorial/PanelFIltroHistorialAdmin";
import { IFilterListaVerificacion } from "./mantenimiento";
import { useHistoricoAdmin } from "../../hooks/CheckList/useHistoricoAdmin";
import { CabeceraTable } from "../../components/Table/CabeceraTable";
import { TableBase2 } from "../../components/Table/TableBase2";
import { PaginationFooterC } from "../../components/PaginationFooter/PaginationFooterC";
import FotosHistorial from "./historial/FotosHistorial";
import { BaseTelerikV1, EViewMode } from "../../components/generic/baseTelerikV1";

function ListaVerificacionHistorial() {
  const {
    isLoading,
    dataTable,
    onChangeComboBox,
    _onkeyUpSearchTable,
    searchBoxRefTable,
    _onChangeChoiceGroup,
    limpiarFiltro,
    filter,
    _onSelectDate,
    filterFechas,
    actualizarTabla,
    onChangeSkip,
    paginacion,
    postTableHistorialCheckList
  } = useHistoricoAdmin();

  const [isFilter, setisFilter] = useState(false);
  /**PanelFiltros*/
  const [isOpenFiltros, { setTrue: openFiltros, setFalse: dismissFiltros }] =
    useBoolean(false);
  /**Panel Reporte Checklist */
  const [isOpenReporte, { setTrue: openReporte, setFalse: dismissReporte }] =
    useBoolean(false);

  const [isOpenAdjunto, { setTrue: openAdjunto, setFalse: dismissAdjunto }] =
    useBoolean(false);
  /** ITEM DE TABLA */
  const [itemSelect, setItemSelect] = useState<IItemListaVerificacion>();

  const navigate = useNavigate();

  var dataFormRevision: IAuditoria = {
    ListaVerificacionId: [],
    InspeccionRadial: false,
    Valoracion: true,
    Comentario: "",
  };
  const itemDataRevision: IItemListaVerificacion = {
    listaVerificacionId: "",
    equipo: "",
    estado: "",
    fecha: "",
    nroDOI: "",
    persona: "",
    guardia: "",
    modelo: "",
    observacion: 0,
    comentario: "",
    observaciones: 0,
    observacionesCriticas: 0,
    cantidadFotos: 0,
    fotos: [],
  };
  const detalleListaVerificacion: IDetalleListaVerificacion = {
    listaVerificacionId: "",
    persona: "",
    equipo: "",
    fecha: "",
    comentario: "",
    estado: "",
    codigoEstado: 0,
    fotos: [],
    observaciones: [],
    detalles: [],
  };
  const [formRevision, setFormRevision] = useState(dataFormRevision);
  const dataRevision: IItemListaVerificacion[] = [];
  const [itemsRevision, setItemsRevision] = useState(dataRevision);
  const theme = getTheme();
  const [openPanel, setOpenPanel] = useState(false);
  const [itemRevision, setItemRevision] = useState(itemDataRevision);
  const [itemDetalleListaVerificacion, setItemDetalleListaVerificacion] =
    useState(detalleListaVerificacion);
  const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] =
    useBoolean(false);
  const [inputComentario, setInputComentario] = useState("");

  // FOTOS CHECKLIST
  const [
    isOpenFotosChecklist,
    { setTrue: openFotosChecklist, setFalse: dismissFotosChecklist },
  ] = useBoolean(false);
  const [fotosRutas, setFotosRutas] = useState<string[]>([]);
  const _items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      onClick: (arg) => actualizarTabla(),
    },
    {
      ...IconHelper.ICON_BS_FILTER,
      text: "Limpiar Filtro",
      onClick: (arg) => limpiarFiltro(),
    },
  ];
  const _farItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_EXCEL,
      onClick: () => {
        navigate(`reporteHistoricoC`);
      },
      // onClick: openReporte,
    },
    {
      key: "reporte",
      text: `${isFilter ? "Limpiar Filtro" : "Filtrar"}`,
      iconProps: { iconName: `${isFilter ? "clearfilter" : "filter"}` },
      onRenderIcon() {
        return IconHelper.ICONFILTER;
      },
      onClick: openFiltros,
    },
  ];

  const _columns: IColumn[] = [
    {
      key: "modelo",
      name: "Modelo",
      fieldName: "modelo",
      minWidth: 150,
      maxWidth: 180,
      isResizable: true,
    },
    {
      key: "equipo",
      name: "Equipo",
      fieldName: "equipo",
      minWidth: 60,
      maxWidth: 60,
      isResizable: true,
    },
    {
      key: "fecha",
      name: "Fecha",
      fieldName: "fecha",
      minWidth: 100,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "estado",
      name: "Estado",
      fieldName: "estado",
      minWidth: 125,
      maxWidth: 130,
      isResizable: true,
      onRender: (item: IItemListaVerificacion) => (
        <Estado value={item.estado} />
      ),
    },
    {
      key: "persona",
      name: "Operador",
      fieldName: "persona",
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
      onRender: (item: IItemListaVerificacion) => (
        <PersonaTag text={item.persona} nroDoi={item.nroDOI}></PersonaTag>
      ),
    },
    {
      key: "Guardia",
      name: "Guardia",
      fieldName: "guardia",
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
    },
    {
      key: "supervisor",
      name: "Supervisor",
      fieldName: "supervisor",
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "comentario",
      name: "Comentario",
      fieldName: "comentario",
      minWidth: 90,
      maxWidth: 90,
      onRender: (item: IItemListaVerificacion) => (
        <div>
          {item.comentario != "" ? (
            <TooltipHost content={item.comentario}>
              <Icon
                iconName="CommentSolid"
                className="ms-fontSize-16"
                style={{ cursor: "pointer", color: "#bebbb8" }}
              />
            </TooltipHost>
          ) : (
            <TooltipHost content="">
              <Icon
                iconName="Comment"
                className="ms-fontSize-16"
                style={{ color: "#bebbb8" }}
              />
            </TooltipHost>
          )}
        </div>
      ),
    },
    {
      key: "observaciones",
      name: "Obs.",
      fieldName: "observaciones",
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
    },
    {
      key: "observacionesCriticas",
      name: "Obs. Críticas",
      fieldName: "observacionesCriticas",
      minWidth: 80,
      maxWidth: 80,
      isResizable: true,
    },
    {
      key: "fotos",
      name: "Fotos",
      fieldName: "cantidadFotos",
      minWidth: 40,
      maxWidth: 40,
      isResizable: true,
      onRender(item: IItemListaVerificacion, index?, column?) {
        if (item.cantidadFotos > 0) {
          return (
            <Icon
              iconName="PhotoCollection"
              className="ms-fontSize-16 "
              style={{
                cursor: "pointer",
                color: COLORES.Bases.neutralSecondaryAlt,
              }}
              onClick={() => {
                setFotosRutas(item.fotos);
                openFotosChecklist();
              }}
            />
          );
        }
      },
    },
    {
      key: "archivo",
      name: "Archivo",
      fieldName: "listaVerificacionId",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
      onRender: (item: IItemListaVerificacion) => (
        <>
          <TooltipHost content="Ver adjunto">
            <Icon
              iconName="PDF"
              className="ms-fontSize-16 "
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => {
                setItemSelect(item);
                openAdjunto();
              }}
            />
          </TooltipHost>
        </>
      ),
    },
  ];
  const optionsActividad: IChoiceGroupOption[] = [
    {
      key: "aprobado",
      text: "Aprobado",
      iconProps: { iconName: "Accept" },
      styles: { root: { color: theme.palette.greenDark } },
      onClick: () => {
        formRevision.Valoracion = false;
      },
    },
    {
      key: "desaprobado",
      text: "Desaprobado",
      color: theme.palette.red,
      iconProps: { iconName: "Cancel", color: theme.palette.redDark },
      styles: { root: { color: theme.palette.red } },
      imageSize: { width: 60, height: 10 },
      onClick: () => {
        formRevision.Valoracion = true;
      },
    },
  ];
  const buttonStyles = { root: { marginRight: 8 } };
  const onRenderFooterContent = React.useCallback(
    () => (
      <div>
        <PrimaryButton
          onClick={() => {
            setOpenPanel(false);
          }}
          styles={buttonStyles}
        >
          Revisar
        </PrimaryButton>
        <DefaultButton onClick={() => setOpenPanel(false)}>
          Cancelar
        </DefaultButton>
      </div>
    ),
    [itemRevision, itemsRevision, formRevision, inputComentario]
  );

  return (
    <div>
      <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg12">
          <CabeceraTable
            SubTitulo="Revisar Histórico de Checklist"
            Titulo="Historial De CheckList"
            placeholder="Buscar operador..."
            componentRef={searchBoxRefTable}
            onKeyUp={_onkeyUpSearchTable}
          />
        </div>
      </div>
      <br />
      <Stack>
        <TableBase2
          leftBar={_items}
          rigthBar={_farItems}
          data={dataTable}
          column={_columns}
          isLoading={isLoading}
          footerPagination={
            <PaginationFooterC
              paginacion={paginacion}
              onChangePagina={(e) => {
                onChangeSkip(e);
              }}
            />
          }
        />
      </Stack>
      <div>
        {/* PANEL PDF ADJUNTO*/}
        <PanelGenerico
          isOpen={isOpenAdjunto}
          onDismiss={dismissAdjunto}
          enabledFooter={true}
          panelType={PanelType.large}
          enabledHeader
          title="Adjunto Historial Checklist"
          subTitle={`${itemSelect?.modelo} - ${itemSelect?.equipo}`}
        >
          <div style={themeBase._padding20}>
            {/* {JSON.stringify(itemSelect?.listaVerificacionId)} */}
            {/* <BaseTelelirk
              viewMode={ETelerikViewmode.PRINT_PREVIEW}
              reportName="ListaVerificacion.trdx"
              parametros={{
                listaVerificacionId: itemSelect?.listaVerificacionId,
              }}
            /> */}
            <BaseTelerikV1
              // viewMode={"PRINT_PREVIEW"}
              reportName="ListaVerificacion.trdx"
              parametros={{
                listaVerificacionId: itemSelect?.listaVerificacionId,
              }}
              viewMode={EViewMode.PRINT_PREVIEW}
            />
          </div>
        </PanelGenerico>

        <PanelFIltroHistorialAdmin
          isOpen={isOpenFiltros}
          onDismiss={dismissFiltros}
          onChangeComboBox={onChangeComboBox}
          onChangeChoiceGroup={_onChangeChoiceGroup}
          filter={filter}
          limpiarFiltro={limpiarFiltro}
          onSelectDate={_onSelectDate}
          fechasFilter={filterFechas}
          buscar={postTableHistorialCheckList}
        />
        {/* PANEL Revision de Checklist */}
        <Panel
          isOpen={openPanel}
          //onDismiss={setOpenPanel(false)}
          onDismiss={() => setOpenPanel(false)}
          type={PanelType.medium}
          closeButtonAriaLabel="Close"
          headerText="Revision de Checklist"
          onRenderFooterContent={onRenderFooterContent}
          isFooterAtBottom={true}
        >
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              {itemRevision.listaVerificacionId != "" && (
                <Text variant="xLarge">
                  {itemRevision.modelo} {itemRevision.equipo}
                </Text>
              )}
              {itemsRevision.length > 0 && (
                <Text variant="xLarge">
                  Revisar los siguientes {itemsRevision.length} equipos:
                </Text>
              )}
            </div>
          </div>
          {itemsRevision.length > 0 && (
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
          )}
          <div className="ms-Grid" dir="ltr">
            {itemsRevision.map(function (object, i) {
              return (
                <div key={i} className="ms-Grid-col ms-sm6 ms-md4 ms-lg4">
                  <Text variant="large">{object.equipo}</Text>
                </div>
              );
            })}
          </div>
          {itemDetalleListaVerificacion.listaVerificacionId != "" && (
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
              <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                <Text variant="medium" className="ms-fontWeight-bold">
                  Persona<br></br>
                </Text>
                <Text variant="large">
                  {itemDetalleListaVerificacion.persona}
                </Text>
              </div>
              <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                <Text variant="medium" className="ms-fontWeight-bold">
                  Fecha<br></br>
                </Text>
                <Text variant="large">
                  {itemDetalleListaVerificacion.fecha}
                </Text>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <Text className="ms-fontWeight-bold">Observaciones</Text>
              </div>
              {itemDetalleListaVerificacion.observaciones.map(function (
                data,
                index
              ) {
                return (
                  <div key={index}>
                    <div className="ms-Grid-col ms-sm10 ms-md10 ms-lg10">
                      {data.codigoOpcion == "02" && (
                        <Icon
                          iconName="WarningSolid"
                          color={theme.palette.redDark}
                          style={{ color: theme.palette.redDark }}
                        ></Icon>
                      )}
                      {data.codigoOpcion == "03" && (
                        <Icon
                          iconName="WarningSolid"
                          color={theme.palette.black}
                          style={{ color: theme.palette.black }}
                        ></Icon>
                      )}
                      &nbsp;
                      <Text variant="smallPlus">
                        {data.propiedadVerificacion}
                      </Text>
                    </div>
                    <div className="ms-Grid-col ms-sm2 ms-md2 ms-lg2">
                      <Text variant="smallPlus" className="ms-fontWeight-bold">
                        {data.opcion}
                      </Text>
                    </div>
                  </div>
                );
              })}
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <Text className="ms-fontWeight-bold">Comentario</Text>
                <br></br>
                <Text className="ms-fontWeight-semiBold">
                  {itemDetalleListaVerificacion.comentario}
                </Text>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <Text className="ms-fontWeight-bold">Fotos</Text>
              </div>
              {itemDetalleListaVerificacion.fotos.map(function (datos, indice) {
                return (
                  <div
                    key={indice}
                    className="ms-Grid-col ms-sm4 ms-md4 ms-lg4"
                  >
                    <Image
                      src={datos}
                      styles={{
                        root: {
                          border: "0px solid " + theme.palette.neutralSecondary,
                        },
                      }}
                      height={150}
                      imageFit={ImageFit.contain}
                      onClick={showModal}
                    ></Image>
                    <Modal
                      titleAriaId={"titleId"}
                      isOpen={isModalOpen}
                      onDismiss={hideModal}
                      isBlocking={false}
                    >
                      <Image
                        src={datos}
                        styles={{
                          root: {
                            border:
                              "0px solid " + theme.palette.neutralSecondary,
                          },
                        }}
                        height={650}
                        imageFit={ImageFit.contain}
                      ></Image>
                    </Modal>
                  </div>
                );
              })}
            </div>
          )}
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
          <Separator>
            {"Verifique las opciones, luego click en revisar"}
          </Separator>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid">
              <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                <ChoiceGroup
                  label="Seleccione actividad a realizar"
                  defaultSelectedKey="taller"
                  options={optionsActividad}
                />
              </div>
              <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                {/* <ChoiceGroup
                label="Seleccione inspección realizada"
                defaultSelectedKey="no"
                options={optionsInspeccion}
              /> */}
                <TextField
                  label="Comentario"
                  multiline
                  resizable={false}
                  onChange={(x, y) => setInputComentario(x.currentTarget.value)}
                />
              </div>
            </div>

            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">&nbsp;</div>
          </div>
        </Panel>

        {/* PANEL FOTOS */}
        <FotosHistorial
          ulrFostos={fotosRutas}
          isOpen={isOpenFotosChecklist}
          dismiss={dismissFotosChecklist}
        />

        {/* PANEL Reporte*/}
        <ReporteHistoricoChecklist
          isOpen={isOpenReporte}
          onDismiss={dismissReporte}
        />
      </div>
    </div>
  );
}
export default ListaVerificacionHistorial;
